import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertOctagon, X, Zap } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { markAdminFestivalEntry } from "@/lib/adminNav";

// Iter389 · Feature 1 — Owner "Enter Live Ops" flow.
// Non-dismissible confirmation modal → POST enter → navigate. On unmount
// (or explicit close inside Live Ops) POST exit is out-of-scope here;
// Live Ops fires it via a beforeunload hook.
export default function OwnerLiveOpsEnterModal({ festival, open, onClose }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  useEffect(() => { setBusy(false); }, [festival?.id, open]);
  if (!open || !festival) return null;
  const confirm = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/festival/${festival.id}/owner-live-ops`, { action: "enter" });
      sessionStorage.setItem("ownerLiveOpsFestivalId", festival.id);
      markAdminFestivalEntry();
      toast.success("Entered as Owner — organiser + deputy notified");
      nav(`/festival/${festival.id}/live`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to enter");
      setBusy(false);
    }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4" data-testid="owner-live-ops-modal">
      <div className="w-full max-w-md bg-[#0A0A0A] border-2 border-[#FFB020] p-5">
        <div className="flex items-start gap-3 mb-3">
          <AlertOctagon className="w-6 h-6 text-[#FFB020] shrink-0 mt-0.5" />
          <div>
            <div className="label-mono text-[#FFB020] text-[10px]">RALLY-LAB · OWNER LIVE OPS</div>
            <h2 className="h-display text-xl mt-1">Enter as Owner</h2>
          </div>
        </div>
        <p className="text-sm text-white mb-3" data-testid="owner-live-ops-copy">
          You are entering <span className="font-bold">{festival.name}</span>'s Live Ops as Owner.
          The organiser and any active deputy will be notified. Confirm?
        </p>
        <div className="text-[10px] uppercase tracking-widest text-[#A3A3A3] mb-4">
          You have full read/write access identical to the organiser.
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            data-testid="owner-live-ops-cancel"
            className="px-4 py-2 text-xs uppercase tracking-widest text-[#A3A3A3] hover:text-white disabled:opacity-40"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirm}
            disabled={busy}
            data-testid="owner-live-ops-confirm"
            className="px-4 py-2 text-xs uppercase tracking-widest bg-[#FFB020] text-black hover:opacity-80 disabled:opacity-40"
          >
            <Zap className="w-3.5 h-3.5 inline mr-1" /> {busy ? "Entering…" : "Confirm & enter"}
          </button>
        </div>
      </div>
    </div>
  );
}
